import { render, staticRenderFns } from "./Workshop3.vue?vue&type=template&id=7756f86c&"
import script from "./Workshop3.vue?vue&type=script&lang=js&"
export * from "./Workshop3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports